export default {
    min: false,
}